export default {
    state: {
        callback: null,
    },
    getters: {
        shouldShow: state => () => (state.callback ? true : false),
        callback: state => state.callback,
    },
    mutations: {
        show(state, callback) {
            state.callback = callback;
        },
        hide(state, _) {
            state.callback = null;
        },
    },
};
